import * as React from "react";
import { useMergeRefs } from "@floating-ui/react";
import { SignatureCanvas } from "react-signature-canvas";
import { Button } from "../../button/button.mjs";
import { FormHelper } from "../form-helper/form-helper.mjs";
import { Grid } from "../../grid/grid/grid.mjs";
import { GridColumn } from "../../grid/grid-column/grid-column.mjs";
import { Icon } from "../../icon/icon/icon.mjs";
import { useTheme } from "../../helpers/theme-provider/use-theme.mjs";
function BEM(props) {
  const { variant = "dark", disabled, employee, isInvalid, className } = props;
  const classArray = ["signature", "signature--".concat(variant)];
  if (disabled) {
    classArray.push("signature--disabled");
  }
  if (employee) {
    classArray.push("signature--employee");
  }
  if (isInvalid) {
    classArray.push("signature--invalid");
  }
  if (className) {
    classArray.push(className);
  }
  return classArray.join(" ");
}
const Signature = (props) => {
  const signatureRef = React.useRef(null);
  const signatureCanvasRef = React.useRef(null);
  const [signature, setSignature] = React.useState();
  const [inlineStyles, setInlineStyles] = React.useState();
  const {
    isFocusable = true,
    label,
    clearButton,
    onClear,
    onEnd,
    onBegin,
    elementRef,
    disabled,
    children,
    employee,
    helpMessage,
    errorMessage,
    successMessage,
    employeeMessage
  } = props;
  const ref = useMergeRefs([elementRef, signatureCanvasRef]);
  const { theme } = useTheme();
  const penColor = theme === "dark" ? "#fff" : "#000";
  const handleOnEnd = () => {
    var _a;
    const signatureFromCanvas = (_a = signatureCanvasRef.current) == null ? void 0 : _a.getCanvas().toDataURL("image/svg+xml");
    setSignature(signatureFromCanvas);
    if (onEnd) {
      onEnd(signatureFromCanvas);
    }
  };
  const handleResize = React.useCallback(() => {
    if (signatureCanvasRef.current) {
      signatureCanvasRef.current.fromDataURL(signature != null ? signature : "");
    }
  }, [signature]);
  React.useEffect(() => {
    if (signatureRef.current) {
      const { clientWidth, clientHeight } = signatureRef.current;
      const aspectRatio = clientWidth < clientHeight ? "".concat(clientHeight, " / ").concat(clientWidth) : "".concat(clientWidth, " / ").concat(clientHeight);
      setInlineStyles({
        height: "auto",
        aspectRatio
      });
    }
  }, []);
  React.useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [handleResize]);
  const getClearButton = (btn) => {
    return /* @__PURE__ */ React.createElement(GridColumn, { width: ["xs"] }, /* @__PURE__ */ React.createElement(Button, { size: "small", iconLeft: "#close", variant: "secondary", type: employee ? "employee" : void 0, disabled, ...btn, onClick: onClear }));
  };
  const getCanvas = () => {
    if (disabled) {
      return null;
    }
    return /* @__PURE__ */ React.createElement(
      SignatureCanvas,
      {
        canvasProps: {
          className: "signature__canvas-inner"
        },
        onBegin,
        onEnd: handleOnEnd,
        ref,
        penColor
      }
    );
  };
  return /* @__PURE__ */ React.createElement("div", { className: BEM(props) }, /* @__PURE__ */ React.createElement(Grid, { align: ["between-xs", "middle-xs", "bottom-xs"], verticalGutter: "small" }, /* @__PURE__ */ React.createElement(GridColumn, { width: ["xs"], className: "signature__label-wrapper" }, /* @__PURE__ */ React.createElement("span", { className: "signature__label" }, employee && /* @__PURE__ */ React.createElement(Icon, { modifiers: "#support", className: "signature__label-icon" }), label), helpMessage && /* @__PURE__ */ React.createElement(FormHelper, { className: "signature__form-helper", text: helpMessage, type: "help" }), errorMessage && /* @__PURE__ */ React.createElement(FormHelper, { className: "signature__form-helper", text: errorMessage, type: "error" }), successMessage && /* @__PURE__ */ React.createElement(FormHelper, { className: "signature__form-helper", text: successMessage, type: "valid" }), employeeMessage && /* @__PURE__ */ React.createElement(FormHelper, { className: "signature__form-helper", text: employeeMessage, type: "employee" })), clearButton && getClearButton(clearButton)), /* @__PURE__ */ React.createElement("div", { className: "signature__canvas", ref: signatureRef, style: inlineStyles, tabIndex: isFocusable ? 0 : void 0 }, children || getCanvas()));
};
export {
  Signature
};
